var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonBreachedPassword = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("rect", { x: 2, y: 6.103, width: 44, height: 23.897, rx: 3.5, fill: fills.light }),
        React.createElement("circle", { cx: 9.698, cy: 18.051, r: 1.698, fill: fills.dark }),
        React.createElement("circle", { cx: 15.851, cy: 18.051, r: 1.698, fill: fills.dark }),
        React.createElement("circle", { cx: 22.005, cy: 18.051, r: 1.698, fill: fills.dark }),
        React.createElement("circle", { cx: 28.159, cy: 18.051, r: 1.698, fill: fills.dark }),
        React.createElement("circle", { cx: 34.313, cy: 18.051, r: 1.698, fill: fills.dark }),
        React.createElement("path", { d: "M22.489 26.85l-7.487 12.498A1.768 1.768 0 0016.514 42h14.972a1.767 1.767 0 001.512-2.651L25.51 26.85a1.768 1.768 0 00-3.022 0z", fill: fills.dark }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 30.394a1 1 0 011 1v3.535a1 1 0 11-2 0v-3.535a1 1 0 011-1zM23 38.465a1 1 0 011-1h.01a1 1 0 110 2H24a1 1 0 01-1-1z", fill: "#fff" }),
        React.createElement("rect", { x: 38.768, y: 12.278, width: 1.232, height: 11.547, rx: 0.616, fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
